<app-modal-shell
  [isOpen]="aberta"
  title="Visualizando planejamento de aula"
  panelClass="max-w-[22.6rem] w-full"
  bodyClass="p-0"
  (fechado)="fechar.emit()">

  <!-- ── Loading ───────────────────────────────────────────────── -->
  <div *ngIf="carregandoDetalhe"
       class="flex flex-col items-center justify-center py-12 gap-3">
    <div class="spinner-brand" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400">Carregando detalhes...</p>
  </div>

  <!-- ── Erro ──────────────────────────────────────────────────── -->
  <div *ngIf="erroDetalhe && !carregandoDetalhe"
       class="flex flex-col items-center justify-center px-4 py-8 text-center">
    <lucide-icon name="alert-triangle" class="h-8 w-8 text-amber-500 mx-auto mb-2"></lucide-icon>
    <p class="text-sm text-gray-600 dark:text-gray-400">Não foi possível carregar os detalhes.</p>
    <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">Verifique sua conexão e tente novamente.</p>
  </div>

  <!-- ── Conteúdo: scroll restrito por calc() independente do pai ─
       130px = header do shell (~64px) + rodapé (~52px) + margem.   -->
  <div *ngIf="!carregandoDetalhe && !erroDetalhe && registroCompleto"
       class="p-4 overflow-y-auto space-y-4 max-h-[calc(85vh-130px)]">

    <!-- SITUAÇÃO -->
    <div *ngIf="exibirSituacao" class="mb-1">
      <span
        class="badge-status gap-1.5 py-1"
        [ngClass]="getSituacaoBadgeClass(situacaoAtual)">
        <span class="w-1.5 h-1.5 bg-white/60 rounded-full"></span>
        {{ getSituacaoLabel(situacaoAtual) }}
      </span>
    </div>

    <!-- 1. TURMA(S) -->
    <div *ngIf="registroCompleto?.itensConteudos?.length" class="mb-6">
      <h4 class="section-title">Turma(s)</h4>

      <div class="flex flex-col gap-3">
        <div *ngFor="let itemConteudo of registroCompleto.itensConteudos; trackBy: trackById">

          <ng-container *ngIf="itemConteudo.itensEducacionais?.length; else formatoAntigo">
            <div class="turma-block">

              <!-- Cabeçalho clicável da turma -->
              <button type="button" (click)="toggleTurmaExpand(itemConteudo)" class="btn-expand">
                <p class="turma-name">{{ itemConteudo.turma?.descricao || itemConteudo.turma?.nome }}</p>
                <lucide-icon
                  name="chevron-down"
                  [class.rotate-180]="itemConteudo.expandido"
                  class="w-4 h-4 text-slate-400 dark:text-gray-500 shrink-0 transition-transform duration-300">
                </lucide-icon>
              </button>

              <!-- Conteúdo expansível -->
              <div *ngIf="itemConteudo.expandido" class="mt-2 space-y-4">

                <ng-container *ngFor="let comp of getComponentesComAulas(itemConteudo, itemConteudo.expandirAulas ? undefined : 3); let isLastComp = last; trackBy: trackByIndex">

                  <!-- Label do Componente Curricular -->
                  <div class="flex items-baseline gap-1.5 pb-1.5 border-b border-slate-200 dark:border-gray-600"
                       [class.mb-3]="!isLastComp"
                       [class.border-b-0]="isLastComp"
                       [class.pb-0]="isLastComp">
                    <span class="text-[10px] font-semibold text-slate-400 dark:text-gray-500 uppercase tracking-wide shrink-0">Componente curricular :</span>
                    <span class="text-xs font-bold text-slate-700 dark:text-gray-100 leading-tight">{{ comp.nome }}</span>
                  </div>

                  <!-- Datas e aulas — só exibidas se existirem -->
                  <div *ngIf="comp.porData.length > 0" class="space-y-3">
                    <ng-container *ngFor="let diaGrupo of comp.porData; let isLastDate = last; trackBy: trackByData">
                      <div>
                        <!-- Data -->
                        <div class="flex items-center gap-2 mb-1.5">
                          <span class="font-semibold text-slate-400 dark:text-gray-500 text-[10px] uppercase w-[52px] shrink-0">Data:</span>
                          <span class="text-xs text-slate-600 dark:text-gray-300">{{ diaGrupo.data | date:'dd/MM/yyyy':'UTC' }}</span>
                        </div>
                        <!-- Aula(s) -->
                        <div class="flex items-start gap-2">
                          <span class="font-semibold text-slate-400 dark:text-gray-500 text-[10px] uppercase w-[52px] shrink-0 pt-0.5">Aula(s):</span>
                          <div class="flex flex-col gap-1.5 w-full">
                            <span *ngFor="let aula of diaGrupo.itens; trackBy: trackById" class="aula-pill self-start">
                              {{ formatarLabelAula(aula) }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <hr *ngIf="!isLastDate" class="border-t border-slate-100 dark:border-gray-700 mt-4">
                    </ng-container>
                  </div>

                </ng-container>

                <!-- Botão Ver todas / Ver menos -->
                <div *ngIf="getTotalAulas(itemConteudo) > 3" class="mt-4 pt-2">
                  <button
                    type="button"
                    (click)="itemConteudo.expandirAulas = !itemConteudo.expandirAulas"
                    class="flex items-center gap-1 text-xs font-bold text-[#3374db] uppercase hover:underline focus:outline-none">
                    <span *ngIf="!itemConteudo.expandirAulas">VER TODAS AS {{ getTotalAulas(itemConteudo) }} AULAS</span>
                    <span *ngIf="itemConteudo.expandirAulas">VER MENOS</span>
                    <lucide-icon
                      [name]="itemConteudo.expandirAulas ? 'chevron-up' : 'chevron-down'"
                      class="w-4 h-4">
                    </lucide-icon>
                  </button>
                </div>

              </div><!-- /conteúdo expansível -->

            </div>
          </ng-container>

          <!-- Sem aulas: mesma borda azul + cabeçalho clicável -->
          <ng-template #formatoAntigo>
            <div class="turma-block">
              <button type="button" (click)="toggleTurmaExpand(itemConteudo)" class="btn-expand">
                <p class="turma-name">{{ itemConteudo.turma?.descricao || itemConteudo.turma?.nome }}</p>
                <lucide-icon
                  name="chevron-down"
                  [class.rotate-180]="itemConteudo.expandido"
                  class="w-4 h-4 text-slate-400 dark:text-gray-500 shrink-0 transition-transform duration-300">
                </lucide-icon>
              </button>

              <!-- Componentes expansíveis -->
              <div *ngIf="itemConteudo.expandido && itemConteudo.itensEducacionais?.length"
                   class="text-xs text-slate-500 dark:text-gray-400 leading-relaxed mt-2">
                <span class="font-semibold text-slate-400 dark:text-gray-500 uppercase text-[10px] tracking-tight pr-1">Componente(s):</span>
                <span class="text-xs font-bold text-slate-700 dark:text-gray-100">
                  <span *ngFor="let ie of itemConteudo.itensEducacionais; let isLast = last; trackBy: trackById">{{ ie.itemEducacional?.descricao || ie.itemEducacional?.nome }}{{ !isLast ? ', ' : '' }}</span>
                </span>
              </div>
            </div>
          </ng-template>

        </div>
      </div>
    </div>

    <!-- 1b. Fallback global itensConteudos não existe -->
    <div *ngIf="!registroCompleto.itensConteudos?.length && turmas.length" class="mb-6">
      <h4 class="section-title">Turma(s)</h4>
      <div class="flex flex-col gap-4">
        <div *ngFor="let t of turmas; trackBy: trackByIndex" class="turma-block">
          <p class="turma-name">{{ t }}</p>
        </div>
      </div>
    </div>

    <!-- 2. PERÍODO -->
    <div>
      <p class="field-label mb-1">Período</p>
      <p class="text-sm text-gray-800 dark:text-gray-200">
        {{ registroCompleto.dataInicio | date:'dd/MM/yyyy':'UTC' }}<ng-container *ngIf="registroCompleto.dataFim"> — {{ registroCompleto.dataFim | date:'dd/MM/yyyy':'UTC' }}</ng-container>
      </p>
    </div>

    <!-- Separador -->
    <hr class="border-gray-200 dark:border-gray-600 border-dashed my-2">

    <!-- 4. DETALHAMENTO — "Ver mais / Ver menos" por item -->
    <div>
      <p class="field-label mb-3">Detalhamento</p>
      <div class="flex flex-col gap-4">
        <div #cardElement *ngFor="let item of detalhamentoList; trackBy: trackById" class="scroll-mt-4">
          <h4 class="text-sm font-semibold text-slate-700 dark:text-gray-200 mb-1.5">{{ item.label }}</h4>
          <div class="card-detalhe">
            <p class="content-text transition-all duration-300"
               [class.line-clamp-3]="!item.expandido">
              {{ item.valor }}
            </p>
            <button *ngIf="item.valor.length > 120"
                    (click)="toggleExpand(item, cardElement)"
                    class="btn-expandir text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
              {{ item.expandido ? 'Ver menos' : 'Ver mais' }}
              <lucide-icon [name]="item.expandido ? 'chevron-up' : 'chevron-down'" class="w-3 h-3"></lucide-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 5. OBSERVAÇÃO -->
    <div *ngIf="observacao">
      <p class="field-label mb-1">Observação</p>
      <div class="border-l-2 border-gray-200 dark:border-gray-600 pl-3 py-1">
        <p class="content-text">{{ observacao }}</p>
      </div>
    </div>

    <!-- 7. ANEXOS -->
    <ng-container *ngIf="possuiAnexos">
      <h4 class="section-title mt-8">Anexos</h4>
      <div class="flex flex-col gap-3">
        <div *ngFor="let arquivo of listaAnexos; trackBy: trackById"
             class="resource-item flex items-center gap-3">
          <lucide-icon name="paperclip" class="w-4 h-4 text-slate-400 dark:text-gray-500 flex-shrink-0"></lucide-icon>
          <div class="flex items-center min-w-0 w-full"
               [title]="arquivo.nome || 'Anexo sem nome'">
            <span class="text-sm font-medium text-slate-700 dark:text-gray-300 truncate">{{ obterNomeSemExtensao(arquivo.nome) }}</span>
            <span class="text-sm font-medium text-slate-700 dark:text-gray-300 flex-shrink-0">{{ obterExtensao(arquivo.nome) }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- 8. LINKS -->
    <ng-container *ngIf="registroCompleto?.links?.length">
      <h4 class="section-title mt-8">Links</h4>
      <div class="flex flex-col gap-3">
        <div *ngFor="let item of registroCompleto.links; trackBy: trackById"
             class="resource-item flex flex-col min-w-0 gap-0.5">
          <span *ngIf="item.descricao && item.descricao !== (item.link || item.url)"
                class="text-sm font-semibold text-slate-700 dark:text-gray-200 truncate"
                [title]="item.descricao">
            {{ item.descricao }}
          </span>
          <span class="text-xs text-slate-500 dark:text-gray-400 line-clamp-2 break-all">
            {{ item.link || item.url }}
          </span>
        </div>
      </div>
    </ng-container>

    <!-- 9. OBSERVAÇÕES DO APROVADOR -->
    <ng-container *ngIf="observacoesAprovador.length">
      <div class="mt-8 border-t border-slate-200 dark:border-gray-600 pt-6">
        <h4 class="text-sm font-bold text-slate-800 dark:text-gray-100 flex items-center gap-2 mb-4">
          <lucide-icon name="message-square" class="w-4 h-4 text-orange-500 shrink-0"></lucide-icon>
          Observações do aprovador
        </h4>

        <div class="bg-orange-50 dark:bg-orange-900/10 border border-orange-100 dark:border-orange-800/40 rounded-lg p-4 space-y-4">
          <div *ngFor="let obs of observacoesAprovador; let i = index; trackBy: trackById"
               [class.border-t]="i > 0"
               [class.border-orange-200]="i > 0"
               [class.pt-4]="i > 0">

            <!-- Cabeçalho: avatar inicial + login + data -->
            <div class="flex items-center gap-2 mb-2">
              <div class="w-6 h-6 rounded-full bg-slate-700 dark:bg-slate-600 text-white flex items-center justify-center text-[10px] font-bold shrink-0">
                {{ (obs.createdBy || 'A').charAt(0).toUpperCase() }}
              </div>
              <p class="text-xs text-slate-700 dark:text-gray-300">
                <span class="font-bold">{{ obs.createdBy || 'Aprovador' }}</span>
                <span class="text-slate-400 dark:text-gray-500 mx-1">·</span>
                <span class="text-slate-500 dark:text-gray-400">{{ obs.createdIn | date:'dd/MM/yyyy HH:mm' }}</span>
              </p>
            </div>

            <!-- Texto da observação com line-clamp expansível -->
            <p class="content-text" [class.line-clamp-3]="!obs.expandido">
              {{ obs.observacao }}
            </p>

            <button *ngIf="(obs.observacao ?? '').length > 150"
                    (click)="obs.expandido = !obs.expandido"
                    class="btn-expandir text-orange-600 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-300">
              {{ obs.expandido ? 'Ler menos' : 'Ler observação completa' }}
              <lucide-icon [name]="obs.expandido ? 'chevron-up' : 'chevron-down'" class="w-3 h-3"></lucide-icon>
            </button>

          </div>
        </div>
      </div>
    </ng-container>

  </div>

  <!-- ── Rodapé fixo — fora da div rolável ─────────────────────── -->
  <div *ngIf="!carregandoDetalhe"
       class="px-4 py-3 border-t border-gray-200 dark:border-gray-700 flex justify-end bg-gray-50 dark:bg-gray-800/50">
    <button type="button" (click)="fechar.emit()" class="btn-fechar">
      FECHAR
    </button>
  </div>

</app-modal-shell>

